<template>
  <v-container v-if="getVendor" class="vendor-profile-page pa-0" fluid>
    <v-alert
      v-if="getVendor.alert"
      border="left"
      type="error"
      transition="slide-y-transition"
      dismissible
      class="mb-4"
      v-model="getVendor.alert"
      color="red"
    >
      <strong>{{ getVendor.note }}</strong>
    </v-alert>

    <Edit
      :editDialog="editDialog"
      @close="editDialog = false"
      @submit="loadData"
      :editVendor="getVendor"
    />

    <v-card outlined class="vendor-profile-card">
      <div class="profile-header">
        <div class="profile-title-wrap">
          <v-btn icon small class="mr-2" @click="$router.go(-1)">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>

          <div>
            <div class="profile-title text-capitalize">
              {{ getVendor.name }}
            </div>
            <div class="profile-subtitle">
              Vendor profile and purchase activity
            </div>
          </div>
        </div>

        <div class="profile-actions">
          <v-btn
            v-if="checkRightStatus(6) && !$vuetify.breakpoint.xsOnly"
            small
            rounded
            color="primary"
            dark
            @click="newPurchase"
          >
            <v-icon left small>mdi-plus</v-icon>
            New Purchase
          </v-btn>

          <v-menu bottom left offset-y>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon small>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list dense class="menu-button">
              <v-list-item
                v-if="checkRightStatus(5) && $vuetify.breakpoint.xsOnly"
                @click="newPurchase"
              >
                <v-list-item-title>New Purchase</v-list-item-title>
              </v-list-item>

              <v-list-item v-if="checkRightStatus(19)" @click="editDialog = true">
                <v-list-item-title>Edit</v-list-item-title>
              </v-list-item>

              <DeleteVendor :vendor="getVendor" @submit="$router.go(-1)" />
              <SyncBalance />
              <Statement :VendorId="getVendor.id" />
            </v-list>
          </v-menu>
        </div>
      </div>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col cols="12" md="4">
            <div class="info-card">
              <div class="info-card-title">Contact</div>

              <div class="info-row">
                <span class="info-label">Contact Name</span>
                <span class="info-value text-capitalize">
                  {{ getVendor.contactName || "Not Set" }}
                </span>
              </div>

              <div class="info-row">
                <span class="info-label">Phone Number</span>
                <span class="info-value">
                  <template v-if="getVendor.phoneNumber">
                    {{ getVendor.phoneNumber | USPhoneNumber }}
                  </template>
                  <template v-else>Not Set</template>
                </span>
              </div>

              <div class="info-row">
                <span class="info-label">Cell Number</span>
                <span class="info-value">
                  <template v-if="getVendor.cellNumber">
                    {{ getVendor.cellNumber | USPhoneNumber }}
                  </template>
                  <template v-else>Not Set</template>
                </span>
              </div>

              <div class="info-row">
                <span class="info-label">Email</span>
                <a v-if="getVendor.email" class="info-value" @click="sendEmail">
                  {{ getVendor.email }}
                </a>
                <span v-else class="info-value">Not Set</span>
              </div>
            </div>
          </v-col>

          <v-col cols="12" md="4">
            <div class="info-card">
              <div class="info-card-title">Address</div>

              <v-tooltip bottom v-if="getVendor.address">
                <template v-slot:activator="{ on }">
                  <a v-on="on" class="address-link" @click="openGoogleMap">
                    <div class="address-line text-capitalize">
                      {{ getVendor.address }}
                    </div>
                    <div class="address-line text-capitalize">
                      {{ getVendor.city }}, {{ getVendor.state }} {{ getVendor.zip }}
                    </div>
                  </a>
                </template>
                <span>Click to open Google map</span>
              </v-tooltip>

              <div v-else class="empty-info">No address set</div>

              <div class="info-row mt-4">
                <span class="info-label">Vendor Since</span>
                <span class="info-value">
                  {{ getVendor.createdAt | moment("from", "now") }}
                </span>
              </div>
            </div>
          </v-col>

          <v-col cols="12" md="4" v-if="checkRightStatus(33)">
            <div class="balance-card">
              <div class="balance-label">Balance</div>
              <div class="balance-value" :style="{ color: balanceColor }">
                {{ getVendor.balance | currency }}
              </div>
              <div class="balance-limit">
                Limit: {{ getVendor.balanceLimit | currency }}
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card outlined class="vendor-tabs-card mt-4">
      <v-tabs v-model="active" color="primary" show-arrows grow>
        <v-tab>{{ $t("labels.dashboard") }}</v-tab>
        <v-tab v-if="checkRightStatus(48)">Purchase Order</v-tab>
        <v-tab>Open Invoice</v-tab>
        <v-tab>Payments</v-tab>
        <v-tab>All Invoice</v-tab>
        <v-tab>Attachment</v-tab>
      </v-tabs>

      <v-divider />

      <v-tabs-items v-model="active" touchless>
        <v-tab-item>
          <div class="tab-content">
            <Dashboard />
          </div>
        </v-tab-item>

        <v-tab-item v-if="checkRightStatus(48)">
          <div class="tab-content">
            <PurchaseOrder v-if="getVendor" :VendorId="getVendor.id" />
          </div>
        </v-tab-item>

        <v-tab-item>
          <div class="tab-content">
            <PurchaseList
              v-if="getVendor"
              :due="true"
              :showAll="true"
              :VendorId="getVendor.id"
            />
          </div>
        </v-tab-item>

        <v-tab-item>
          <div class="tab-content">
            <PaymentList v-if="getVendor" :VendorId="getVendor.id" />
          </div>
        </v-tab-item>

        <v-tab-item>
          <div class="tab-content">
            <PurchaseList v-if="getVendor" :VendorId="getVendor.id" />
          </div>
        </v-tab-item>

        <v-tab-item>
          <div class="tab-content">
            <AttachmentList v-if="getVendor" TypeId="12" :RelationId="getVendor.id" />
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>

  <v-container v-else fluid class="vendor-profile-page pa-4">
    <v-card outlined class="loading-card">
      <v-card-text class="text-center py-12">
        <v-progress-circular size="56" width="6" color="primary" indeterminate />
        <div class="mt-4">Loading vendor...</div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
const Dashboard = () => import("@/modules/Inventory/Vendor/components/Dashboard");
const PurchaseList = () => import("@/modules/Inventory/Purchase/components/List");
const AttachmentList = () => import("@/modules/Attachment/components/List");
const PurchaseOrder = () => import("@/modules/Inventory/PurchaseOrder/components/List");
const PaymentList = () => import("@/modules/Inventory/Payment/components/List");
const DeleteVendor = () => import("@/modules/Inventory/Vendor/components/DeleteVendor");
const Statement = () => import("@/modules/Inventory/Vendor/components/Statement");
const SyncBalance = () => import("@/modules/Inventory/Vendor/components/syncBalance.vue");
const Edit = () => import("@/modules/Inventory/Vendor/components/Edit");

import { mapGetters, mapActions } from "vuex";
import Hashids from "hashids";

const hashids = new Hashids();

export default {
  name: "Vendor-profile",

  components: {
    Edit,
    Dashboard,
    SyncBalance,
    Statement,
    PurchaseList,
    AttachmentList,
    PaymentList,
    PurchaseOrder,
    DeleteVendor,
  },

  data() {
    return {
      fab: false,
      active: null,
      editDialog: false,
    };
  },

  computed: {
    ...mapGetters("vendor", ["getVendor"]),
    ...mapGetters("global", ["checkRightStatus"]),

    balanceColor() {
      if (!this.getVendor) {
        return "#0f172a";
      }

      return Number(this.getVendor.balance || 0) > Number(this.getVendor.balanceLimit || 0)
        ? "#dc2626"
        : "#16a34a";
    },
  },

  watch: {
    $route(to, from) {
      if (to && from && to.name === from.name) {
        this.loadData();
      }
    },
  },

  created() {
    this.loadData();
    this.$events.listen("VendorProfileEvent", () => this.loadData());
  },

  beforeDestroy() {
    this.$events.remove("VendorProfileEvent");
  },

  methods: {
    ...mapActions("vendor", ["setVendor"]),
    ...mapActions("global", ["setPageTitle"]),

    viewOpenInvoice() {
      const hashId = hashids.encode(this.getVendor.id);
      const routeData = this.$router.resolve({
        path: `/global/invoice/${hashId}/openInvoice`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },

    newPurchase() {
      this.$router.push({
        path: `/inventory/purchase/create?VendorId=${this.getVendor.id}`,
      });
    },

    async loadData() {
      const id = this.$route.params.id;
      this.$Progress.start();
      await this.setVendor(id);
      this.$Progress.finish();
    },

    openGoogleMap() {
      window.open(
        `https://www.google.com/maps/place/${this.getVendor.address} ${this.getVendor.city},${this.getVendor.state} ${this.getVendor.zip}`,
        "_blank"
      );
    },

    sendEmail() {
      const routeData =
        "https://mail.google.com/mail/?view=cm&fs=1&to=" + this.getVendor.email;
      window.open(routeData, "newwindow", "width=800, height=950");
    },

    closeEdit() {
      this.editDialog = false;
    },

    updated() {
      this.closeEdit();
      this.loadData();
    },
  },
};
</script>

<style scoped>
.vendor-profile-page {
  background: #f8fafc;
}

.vendor-profile-card,
.vendor-tabs-card,
.loading-card {
  border-radius: 20px;
  background: #ffffff;
  overflow: hidden;
}

.profile-header {
  padding: 16px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.profile-title-wrap {
  display: flex;
  align-items: center;
}

.profile-title {
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
}

.profile-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
}

.profile-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.info-card,
.balance-card {
  background: #f8fafc;
  border-radius: 16px;
  padding: 16px;
  height: 100%;
}

.info-card-title {
  font-size: 14px;
  font-weight: 800;
  color: #0f172a;
  margin-bottom: 12px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 8px 0;
  border-bottom: 1px solid #e2e8f0;
}

.info-row:last-child {
  border-bottom: none;
}

.info-label {
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
}

.info-value {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  text-align: right;
}

.address-link {
  display: block;
  color: #0f172a;
  text-decoration: none;
}

.address-link:hover {
  text-decoration: underline;
}

.address-line {
  font-size: 14px;
  font-weight: 700;
}

.empty-info {
  color: #64748b;
  font-size: 13px;
}

.balance-label {
  font-size: 12px;
  color: #64748b;
  font-weight: 700;
}

.balance-value {
  font-size: 34px;
  font-weight: 800;
  line-height: 1.1;
  margin-top: 6px;
}

.balance-limit {
  font-size: 13px;
  color: #64748b;
  margin-top: 6px;
}

.tab-content {
  padding: 16px;
}

@media (max-width: 600px) {
  .profile-actions {
    width: 100%;
    justify-content: flex-end;
  }

  .info-row {
    flex-direction: column;
    gap: 4px;
  }

  .info-value {
    text-align: left;
  }

  .tab-content {
    padding: 10px;
  }
}
</style>
